import { useEffect, useState } from "react";
import "../App.css";
import TUMBUHImage from "../image/tumbuhlogo.png";

export default function Events() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch("/data/events.json")
      .then((r) => r.json())
      .then(setItems)
      .catch((e) => console.error("Failed to load events.json", e));
  }, []);

  const handleView = (route) => {
    const isLocalhost = window.location.hostname === "localhost";

    const base = isLocalhost
      ? "http://localhost:3000"
      : "https://tedxsetapak.com";

    window.open(`${base}${route}`, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="events" className="events-section">
      <div className="container">

        {/* Section Heading */}
        <h2 className="mb-4 text-center">
          Explore Our Events
        </h2>

        <div className="row g-4 justify-content-center">
{[...items]
  .sort((a, b) => {
    // Sort by year, newest first
    return Number(b.title) - Number(a.title);
  })
  .map((event) => {

            // Identify TEDxSetapak 2026
            const isEvent2 =
              String(event.title ?? "").trim() === "2026";

            // Enable View Event for 2026
            const isActive =
              isEvent2 ||
              String(event.Active ?? "").trim().length > 0;

            // Replace 2026 image with TUMBUH logo
            const eventImage = isEvent2
              ? TUMBUHImage
              : event.image;

            // Route 2026 to the new event page
            const eventRoute = isEvent2
              ? "/#/event2/theme"
              : event.route;

            return (
              <div key={event.id} className="col-auto">

                <div
                  className={`card bg-dark text-white shadow-sm event-card ${
                    isEvent2 ? "event-card-current" : "border-0"
                  }`}
                  style={{
                    width: "fit-content",
                  }}
                >

                  {/* Event Image Container */}
                  <div className="event-image-container">

                    {/* Current Event Badge */}
                    {isEvent2 && (
                      <span className="event-current-badge">
                        CURRENT EVENT
                      </span>
                    )}

                    {/* Event Image */}
                    <img
                      src={eventImage}
                      alt={`${event.title} Event`}
                      className="d-block mx-auto"
                      style={{
                        width: "480px",
                        maxWidth: "100%",
                        height: "190px",
                        objectFit: isEvent2 ? "contain" : "cover",
                        objectPosition: "center",
                        backgroundColor: "#000",
                        display: "block",
                      }}
                    />

                  </div>

                  {/* Event Information */}
                  <div className="card-body text-center p-3">

                    <h5 className="card-title mb-2">
                      {event.title}
                    </h5>

                    {/* View Event / Coming Soon */}
                    {isActive ? (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleView(eventRoute)}
                      >
                        {isEvent2
                          ? "Explore 2026 Event →"
                          : "View 2025 Event"}
                      </button>
                    ) : (
                      <span
                        className="btn"
                        style={{
                          border: "1px solid white",
                          color: "white",
                          cursor: "default",
                          pointerEvents: "none",
                        }}
                      >
                        Coming Soon
                      </span>
                    )}

                  </div>
                </div>
              </div>
            );
          })}

          {/* No Events */}
          {items.length === 0 && (
            <div className="text-center text-muted">
              No events to show right now.
            </div>
          )}

        </div>
      </div>
    </section>
  );
}